export default async function getInteractive({ context, nextMiddleware }){
    try {
        context.store.dispatch('menuUI/selectTab', 'interactive');
    }
    catch(e){
        console.error(e);
        return context.next(false);
    }
    return nextMiddleware()
}
